/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingSubscription } from './BillingSubscription';
import {
    BillingSubscriptionFromJSON,
    BillingSubscriptionFromJSONTyped,
    BillingSubscriptionToJSON,
    BillingSubscriptionToJSONTyped,
} from './BillingSubscription';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { CompanyOnboarding } from './CompanyOnboarding';
import {
    CompanyOnboardingFromJSON,
    CompanyOnboardingFromJSONTyped,
    CompanyOnboardingToJSON,
    CompanyOnboardingToJSONTyped,
} from './CompanyOnboarding';
import type { CompanySetting } from './CompanySetting';
import {
    CompanySettingFromJSON,
    CompanySettingFromJSONTyped,
    CompanySettingToJSON,
    CompanySettingToJSONTyped,
} from './CompanySetting';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * Defines some basic information about a company
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    status: CompanyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    ref: string;
    /**
     * The locales a company can be set to, which drive both translations and the formatting of dates and numbers.
     * @type {string}
     * @memberof Company
     */
    locale: CompanyLocaleEnum;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    timezone: string;
    /**
     * A series of national/public holidays that apply to this company
     * @type {number}
     * @memberof Company
     */
    holidayRegionId: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    updatedAt: Date | null;
    /**
     * 
     * @type {Array<Location>}
     * @memberof Company
     */
    locations?: Array<Location>;
    /**
     * 
     * @type {Address}
     * @memberof Company
     */
    address: Address;
    /**
     * 
     * @type {CompanySetting}
     * @memberof Company
     */
    companySetting?: CompanySetting;
    /**
     * 
     * @type {CompanyOnboarding}
     * @memberof Company
     */
    companyOnboarding?: CompanyOnboarding;
    /**
     * 
     * @type {BillingSubscription}
     * @memberof Company
     */
    latestSubscription: BillingSubscription | null;
    /**
     * A list of feature flags enabled for the company.
     * @type {Array<string>}
     * @memberof Company
     */
    featureFlags: Array<CompanyFeatureFlagsEnum>;
}

/**
* @export
* @enum {string}
*/
export enum CompanyStatusEnum {
    Active = 'Active',
    Locked = 'Locked',
    Suspended = 'Suspended',
    Closed = 'Closed'
}
/**
* @export
* @enum {string}
*/
export enum CompanyLocaleEnum {
    EnGb = 'en-GB',
    EnUs = 'en-US',
    FrFr = 'fr-FR'
}
/**
* @export
* @enum {string}
*/
export enum CompanyFeatureFlagsEnum {
    AccountantNumber = 'Accountant Number',
    FrenchTranslation = 'French Translation',
    LockPayPeriods = 'Lock Pay Periods',
    PortalOfflineMode = 'Portal offline Mode',
    ScheduleMonthView = 'Schedule Month View',
    ScheduleTimeOffView = 'Schedule Time Off View',
    ShiftCostsReport = 'Shift Costs Report'
}


/**
 * Check if a given object implements the Company interface.
 */
export function instanceOfCompany(value: object): value is Company {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    if (!('locale' in value) || value['locale'] === undefined) return false;
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('holidayRegionId' in value) || value['holidayRegionId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latestSubscription' in value) || value['latestSubscription'] === undefined) return false;
    if (!('featureFlags' in value) || value['featureFlags'] === undefined) return false;
    return true;
}

export function CompanyFromJSON(json: any): Company {
    return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Company {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': json['status'],
        'ref': json['ref'],
        'locale': json['locale'],
        'timezone': json['timezone'],
        'holidayRegionId': json['holidayRegionId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
        'locations': json['locations'] == null ? undefined : ((json['locations'] as Array<any>).map(LocationFromJSON)),
        'address': AddressFromJSON(json['address']),
        'companySetting': json['companySetting'] == null ? undefined : CompanySettingFromJSON(json['companySetting']),
        'companyOnboarding': json['companyOnboarding'] == null ? undefined : CompanyOnboardingFromJSON(json['companyOnboarding']),
        'latestSubscription': BillingSubscriptionFromJSON(json['latestSubscription']),
        'featureFlags': json['featureFlags'],
    };
}

  export function CompanyToJSON(json: any): Company {
      return CompanyToJSONTyped(json, false);
  }

  export function CompanyToJSONTyped(value?: Company | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'status': value['status'],
        'ref': value['ref'],
        'locale': value['locale'],
        'timezone': value['timezone'],
        'holidayRegionId': value['holidayRegionId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
        'locations': value['locations'] == null ? undefined : ((value['locations'] as Array<any>).map(LocationToJSON)),
        'address': AddressToJSON(value['address']),
        'companySetting': CompanySettingToJSON(value['companySetting']),
        'companyOnboarding': CompanyOnboardingToJSON(value['companyOnboarding']),
        'latestSubscription': BillingSubscriptionToJSON(value['latestSubscription']),
        'featureFlags': value['featureFlags'],
    };
}

